import React from "react";
import { connect } from "react-redux";
import { getIcon, toMoney } from "../../Components/Functions";
import CreditCard from "../../Components/creditCard";
import Layout from "../../Components/Layout";
import { loggedUser } from "../../Constants/menus";
import { closePanel, openPanel } from "../../Redux/Panels/RightPanel/actions";
import Api from "../../Server/Api";
import BankUpdateForm from "./BankUpdateForm";
import BankWithdrawalForm from "./BankWithdrawalForm";
import { alertBox } from "../../Components/Functions";
import Transactions from "./Transactions";

const api = new Api();

export const BankUpdateForm2 = (props) => {
	return <BankUpdateForm {...props} />;
};

export const BankWithdrawalForm2 = (props) => {
	return <BankWithdrawalForm {...props} />;
};

const WalletOverview = (props) => {
	const [wallet, setWallet] = React.useState({});

	const initBanking = () => {
		api
			.get({ endpoint: `users/${loggedUser?.username}/transaction_summary/` })
			.then((res) => {
				if (res) setWallet(res);
			});
	};

	const showPrompt = () => {
		alertBox({
			title: "No Bank Account added yet",
			message: "Do you want to add an account now?",
			btnCallback: "Yes, Continue",
			callback: () => {
				// props.logout();
				document.getElementById("update-bank-details").click();
				// window.location = "?";
			},
		});
	};

	React.useEffect(() => {
		try {
			initBanking();
		} catch (error) {}
	}, []);

	return (
		<Layout sidePanel={true} title={"Wallet Overview"}>
			<div className="banking-dashboard banking-dashboard-v2 ecommerce-dashboard ecommerce-dashboard-v1">
				{/*Panel*/}
				<div className="dashboard-card is-card-panel">
					<div className="columns is-gapless">
						<div className="column is-6">
							{/*Box*/}
							<div className="inner-box">
								<div className="cards-wrapper">
									<div className="cards-carousel">
										<div className="cards-carousel-inner">
											{/*Carousel Item*/}
											<div className="cards-carousel-item">
												<CreditCard
													name={`@${loggedUser?.username}`}
													balance={toMoney(wallet?.balance)}
													pendingBalance={toMoney(wallet?.pending_balance)}
												/>
												<button
													className="button h-button is-danger mt-4 is-raised is-fullwidth logout-button"
													id="update-bank-details"
													style={{ borderRadius: 10 }}
													onClick={() => {
														props?.openPanel({
															title: "Bank Details",
															content: BankUpdateForm2({ ...props }),
														});
													}}
												>
													<span className="icon is-small">
														<i data-feather="credit-card" />
													</span>
													<span>Update Bank Details</span>
												</button>
												<button
													className="button h-button is-primary mt-4 is-raised is-fullwidth logout-button"
													style={{ borderRadius: 10 }}
													onClick={() => {
														Object.keys(props?.user?.user.bank).length === 0
															? showPrompt()
															: props?.openPanel({
																	title: "Make a Withdrawal",
																	content: BankWithdrawalForm2({
																		...props,
																		wallet,
																		initBanking,
																	}),
															  });
													}}
												>
													<span className="icon is-small">
														<i data-feather="credit-card" />
													</span>
													<span>Withdraw to Bank</span>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="column is-6">
							{/*Box*/}
							<div className="inner-box">
								<div className="box-title">
									<h3>Balance</h3>
								</div>
								{/*Balance*/}
								<div className="card-balance-wrap">
									<div className="card-balance">
										<span>{toMoney(wallet?.balance)}</span>
										<span>Pending Balance: <strong>{toMoney(wallet?.pending_balance)}</strong></span>
									</div>
									<div className="card-balance-stats">
										<div className="card-balance-stat">
											<div className="stat-title">
												<span>Inflow</span>
											</div>
											<div className="stat-block">
												<div
													className="stat-icon is-up"
													dangerouslySetInnerHTML={{
														__html: getIcon("arrow-right"),
													}}
												></div>
												<div className="stat-text">
													<span>{toMoney(wallet?.inflow)}</span>
												</div>
											</div>
										</div>
										<div className="card-balance-stat">
											<div className="stat-title">
												<span>Outflow</span>
											</div>
											<div className="stat-block">
												<div
													className="stat-icon is-down"
													dangerouslySetInnerHTML={{
														__html: getIcon("arrow-right"),
													}}
												></div>
												<div className="stat-text">
													<span>{toMoney(wallet?.outflow)}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Transactions />
			</div>
		</Layout>
	);
};

const mapStateToProps = ({ user }) => {
	return { user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
		openPanel: (e) => dispatch(openPanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletOverview);
